export const QUESTIONNAIRE_TASK = "QUESTIONNAIRE_TASK";
export const WORD_TASK = "WORD_TASK";
export const TIME_TASK = "TIME_TASK";
export const EMOTION_IDENTIFICATION_TASK = "EMOTION_IDENTIFICATION_TASK";
export const TAPPING_TASK = "TAPPING_TASK";
export const ONE_BACK_TASK = "ONE_BACK_TASK";
export const STOP_OR_GO_TASK = "STOP_OR_GO_TASK";
export const SENTENCE_TASK = "SENTENCE_TASK";
export const FACIAL_RECOGNITION_TASK = "FACIAL_RECOGNITION_TASK";
